import React from 'react';
import { Reveal } from './Reveal';
export function Guarantee() {
  return <section className="w-full bg-mint px-4 py-20 sm:py-24" data-id="element-101" data-mp="1o3ne23a6eqyf">
      <Reveal className="mx-auto max-w-2xl rounded-2xl border border-green bg-surface p-9 text-center shadow-premium sm:p-12" data-id="element-102" data-mp="1o33t0dp8bmg6">
        <div className="text-5xl" data-id="element-103" data-mp="22128jmfadox9">🛡️</div>
        <h2 className="mt-5 font-display text-4xl font-extrabold leading-tight tracking-tight text-ink sm:text-5xl" data-id="element-104" data-mp="1x421b86pag4k">
          Zero Risk. 7-Day Money-Back Guarantee.
        </h2>
        <p className="mt-6 text-sm leading-7 text-slate sm:text-base" data-id="element-105" data-mp="14fxtoh4kjsz8">
          Open every volume. Use the class plans in your step classes. Print the resources. Apply the protocols. Teach
          with the drill bank. If within 7 days you feel this wasn’t what you expected, email us and we’ll refund 100% of
          your money. No forms. No questions. No hassle. The risk is entirely ours.
        </p>
        <p className="mt-7 font-semibold text-green-dark" data-id="element-106" data-mp="lpohqfizcmuc">✅ Real refund rate: less than 1%</p>
      </Reveal>
    </section>;
}